export default __webpack_public_path__ + "static/media/vehicle.a70149cbee38207b05eae2da7a63efcf.svg";